export const HOTEL_CANDIDATE_ENDPOINT_KEY = 'hotel-candidate'
